import * as ActionTypes from "constants-lib/actionTypes"
import axios from "axios"
import URITemplate from "urijs/src/URITemplate"
import get from "lodash/get"
import mapValues from "lodash/mapValues"
import { urls } from "utils-lib/builds"
import { getTokenAction } from "../getToken"

export const pendingAC = (data) => ({
  type: ActionTypes.GET_MULTI_ACCOUNT_REDESIGNED_DASHBOARD_DETAILS_PENDING,
  payload: data,
})

export const failedAC = (data) => ({
  type: ActionTypes.GET_MULTI_ACCOUNT_REDESIGNED_DASHBOARD_DETAILS_FAILED,
  payload: data,
})

export const fulfilledAC = (data) => ({
  type: ActionTypes.GET_MULTI_ACCOUNT_REDESIGNED_DASHBOARD_DETAILS_FULFILLED,
  payload: data,
})

/**
 * Fetches details for redesigned dashboard services based on customer IDs and updates state accordingly.
 * @param {Array<string>|null} customerIds - An array of customer IDs to fetch services for, or null to fetch for all linked accounts.
 * @param {boolean} callWithoutUpdate - If true, does not update the state with the fetched data.
 * @returns {Function} A function that takes dispatch and getState as arguments and returns a Promise.
 */
export const getNewMultiAccountRedesignedDashboardDetails =
  () => (dispatch, getState) => {
    const state = getState()
    const api = `GET_REDESIGNED_MULTIACCOUNT_DASHBOARD_DETAILS`
    const template = URITemplate(urls.url[api])
    const userId = state.userAccount?.userDetails?.userId

    const url = template.expand({
      userId,
    })

    const config = {
      headers: {},
    }

    return getTokenAction(dispatch, getState).then((token) => {
      config.headers = {
        oktatoken: token.accessToken,
        apiKey: get(urls, `apiKey.USER[${api}]`, ``),
      }

      return getRedesignedDashboardServicesDetailsHelper(url, config, dispatch)
    })
  }

/**
 * Fetches details for redesigned dashboard services and dispatches actions based on the response.
 * @param {string} url - The URL to fetch the service details from.
 * @param {Object} config - Axios configuration object for the request.
 * @param {Object} data - The payload to be sent with the POST request.
 * @param {boolean} callWithoutUpdate - Flag indicating whether to update the state with the fetched data.
 * @returns {Promise<Object>} A promise that resolves with the fetched service details and status code, or rejects with an error.
 */
export const getRedesignedDashboardServicesDetailsHelper = (
  url,
  config,
  dispatch,
) => {
  dispatch(pendingAC())

  return axios
    .create(config)
    .get(url)
    .then((response) => {
      const statusCode = get(response, `status`, ``)
      const accountsResponseData = get(response, `data`, {})

      const transformedData = {
        ...accountsResponseData,
        data: mapValues(accountsResponseData.data, (currency) => ({
          ...currency,
          accounts: (currency.accounts || []).map(
            ({ customerId, ...rest }) => ({
              custAccountId: customerId,
              ...rest,
            }),
          ),
        })),
      }

      dispatch(
        fulfilledAC({
          accountsResponseData: transformedData,
        }),
      )

      return {
        ...accountsResponseData,
        statusCode,
      }
    })
    .catch((error) => {
      dispatch(
        failedAC({
          statusCode: get(error, `response.status`, ``),
        }),
      )
    })
}
